<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-toolbar>
        <v-toolbar-title>{{
          $t('COMMUNICATION_OPTIONS.ITEMS')
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark color="indigo" @click="optionCreate()">
          <v-icon left>mdi-plus</v-icon>
          {{ $t('ITEM.NEW') }} {{ $t('COMMUNICATION_OPTIONS.ITEM') }}
        </v-btn>
      </v-toolbar>
    </v-col>

    <v-row>
      <v-col cols="12">
        <v-card flat tile>
          <v-data-table
            :headers="headers"
            :items="communicationOptions"
            :sort-by="'name'"
            :sort-desc="true"
          >
            <template v-slot:item.actions="{ item }">
              <div class="text-center">
                <v-list-item @click="optionShow(item)">
                  <v-list-item-title>
                    <v-icon class="mr-1" small>mdi-square-edit-outline</v-icon>
                    {{ $t('ITEM.EDIT') }}
                  </v-list-item-title>
                </v-list-item>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-dialog
        v-if="optionDialog"
        v-model="optionDialog"
        persistent
        max-width="600px"
      >
        <option-form :option="option" @isValid="isValid" @setOption="setOption">
          <template v-slot:header>
            <span v-if="option === null" class="text-h5"
              >{{ $t('ITEM.CREATE') }}
              {{ $t('COMMUNICATION_OPTIONS.ITEM') }}</span
            >
            <span v-if="option !== null" class="text-h5"
              >{{ $t('ITEM.EDIT') }}
              {{ $t('COMMUNICATION_OPTIONS.ITEM') }}</span
            >
            <v-spacer></v-spacer>
            <v-btn icon @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <template v-slot:buttons>
            <v-btn outlined depressed color="grey" @click="closeDialog">
              {{ $t('BUTTON.CANCEL') }}
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
              v-if="option !== null"
              color="primary"
              depressed
              type="submit"
              :disabled="!valid"
              @click="updateOption"
            >
              {{ $t('BUTTON.UPDATE') }}
            </v-btn>
            <v-btn
              v-if="option === null"
              color="primary"
              depressed
              type="submit"
              :disabled="!valid"
              @click="saveOption"
            >
              {{ $t('BUTTON.SAVE') }}
            </v-btn>
          </template>
        </option-form>
      </v-dialog>
    </v-row>
  </v-row>
</template>

<script>
export default {
  name: 'CommunicationOptionsPage',

  components: {
    OptionForm: () =>
      import(
        '@/modules/communication_options/components/CommunicationOptionsForm.vue'
      )
  },

  data: () => ({
    communicationOptions: [],
    option: null,
    optionDialog: false,
    valid: false,
    editedOption: null,
    unwatch: null
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          value: 'id'
        },
        {
          text: this.$t('ITEM.NAME'),
          value: 'translation.name',
          sortable: true
        },
        {
          text: this.$t('ITEM.DESCRIPTION'),
          value: 'translation.description',
          align: 'center'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'actions',
          align: 'center',
          sortable: false
        }
      ];
    }
  },

  created() {
    this.fetchOptions();
    this.unwatch = this.$store.watch(
      state => state.localization.lang,
      () => {
        const lang = this.$store.state.localization.lang;

        if (lang) {
          this.fetchOptions();
        }
      }
    );
  },

  destroyed() {
    this.unwatch();
  },

  methods: {
    fetchOptions() {
      this.$store
        .dispatch('communication_options/index')
        .then(({ data }) => (this.communicationOptions = data.data));
    },

    optionShow(val) {
      this.option = val;
      this.optionDialog = true;
      this.valid = true;
    },

    optionCreate() {
      this.option = null;
      this.optionDialog = true;
      this.valid = false;
    },

    isValid(val) {
      this.valid = val;
    },

    setOption(val) {
      this.editedOption = val;
    },

    optionUpdated() {
      this.$store.commit('snackbar/setSnack', {
        status: 'success',
        text: this.$t('MESSAGE.SUCCESS')
      });
      this.closeDialog();
      this.fetchOptions();
    },

    saveOption() {
      this.$store
        .dispatch('communication_options/store', {
          ...this.editedOption
        })
        .then(() => this.optionUpdated())
        .catch(error => {
          this.error = error.response;
        });
    },

    updateOption() {
      this.$store
        .dispatch('communication_options/update', {
          ...this.editedOption
        })
        .then(() => this.optionUpdated())
        .catch(error => {
          this.error = error.response;
        });
    },

    closeDialog() {
      (this.option = null), (this.optionDialog = false);
    }
  }
};
</script>
